import { createFileRoute } from "@tanstack/react-router"
import { EmailSendPage } from "@/pages/profile/email-send"

export const Route = createFileRoute("/_authenticated/profile/email/send")({
	component: EmailSendPage,
})
